import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import classNames from 'classnames';
import { FunctionComponent, useEffect } from 'react';
import AuthStep from './components/organisms/AuthStep';
import PaymentStep from './components/organisms/PaymentStep';
import ShippingStep from './components/organisms/ShippingStep';
import { useCheckoutState } from './utils/checkoutState';
import { Step } from './utils/step';
import useStickyScrolling from './utils/useStickyScrolling';

let Basket: FunctionComponent<{ desktopStickyStyle?: React.CSSProperties }> | undefined;
if (HAS_BASKET) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
  Basket = require('./components/organisms/Basket').default;
}

let Header: FunctionComponent | undefined;
let Footer: FunctionComponent | undefined;

if (!IS_WEB_COMPONENT) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
  Header = require('./components/atoms/Header').default;
  // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
  Footer = require('./components/atoms/Footer').default;
}

const stepComponents: Record<Step, FunctionComponent> = {
  auth: AuthStep,
  shipping: ShippingStep,
  payment: PaymentStep,
};

const App = () => {
  const { currentStep } = useCheckoutState();
  const { contentRef, contentStyles, basketStyles } = useStickyScrolling();

  // useEffect(() => {
  //   if (!IS_DEVELOPMENT) {
  //     Sentry.init({
  //       dsn: SENTRY_CONTAINER,
  //       integrations: [new Integrations.BrowserTracing()],
  //       environment: process.env.NODE_ENV,
  //       debug: false,
  //       release: RELEASE_ID ?? 'local',
  //       tracesSampleRate: 0,
  //       sampleRate: 1,
  //       attachStacktrace: true,
  //       beforeSend: event => {
  //         // Check if the error is coming from the web component so the parent errors aren't logged
  //         const isWebComponentError =
  //           event.exception?.values?.[0].stacktrace?.frames?.[0].filename?.includes('ay-checkout');

  //         return isWebComponentError ? event : null;
  //       },
  //     });
  //   }
  // }, []);

  const CurrentStep = stepComponents[currentStep];

  return (
    <div>
      {Header && (
        <div className="show-mobile">
          <Header />
        </div>
      )}
      <div className={classNames({ main: HAS_BASKET })}>
        <div className="content-container" ref={contentRef} style={contentStyles}>
          <div className="content-container__max-width">
            {Header && (
              <div className="show-desktop">
                <Header />
              </div>
            )}
            <div className="form-container">
              <CurrentStep />
            </div>
          </div>
        </div>
        {Basket && <Basket desktopStickyStyle={basketStyles} />}
      </div>
      {Footer && <Footer />}
    </div>
  );
};

export default App;
// export default Sentry.withProfiler(App, { name: 'Checkout V3' });
